import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer.tsx";
import { Pagination } from "../components/Pagination.tsx";
import { useQuery } from "@tanstack/react-query";
import { fetcGalery, fetcGaleryBunner, fetchGallerySeo } from "../Services/Requests.js";
import { useRecoilValue } from "recoil";
import { Languege } from "../Atom/index.js";
import Loading from "../components/Loading.tsx";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import galleryTag from "../assets/images/galleryTag.svg";
import { Helmet } from "react-helmet-async";

export default function Galery() {
  const [page, setPage] = useState<number>(1);
  const language = useRecoilValue(Languege);

  const {
    data: GAlery,
    isLoading: loadingGAlery,
    error: errorGAlery,
  } = useQuery({
    queryKey: ["Galery", page],
    queryFn: () => fetcGalery(page),
  });

  const {
    data: GallerySeo,
    isLoading: loadingGallerySeo,
    error: errorGallerySeo,
  } = useQuery({
    queryKey: ["GallerySeo", page],
    queryFn: fetchGallerySeo,
  });

  const {
    data: GAleryBunner,
    isLoading: loadingGAleryBunner,
    error: errorGAleryBunner,
  } = useQuery({
    queryKey: ["GaleryBunner", language],
    queryFn: fetcGaleryBunner,
  });

  useEffect(() => {
    if (!GAlery) return;

    Fancybox.bind("[data-fancybox]", {
      dragToClose: true,
    });

    return () => {
      Fancybox.destroy();
    };
  }, [GAlery]);

  if (loadingGAlery || loadingGAleryBunner) return <Loading />;
  if (errorGAlery || errorGAleryBunner) return <div>Error loading data</div>;

  return (
    <>
      <Helmet>
        {GallerySeo?.title && <title>{GallerySeo?.title}</title>}
        {GallerySeo?.description && (
          <meta name="description" content={GallerySeo?.description} />
        )}
      </Helmet>
      <div>
        <Header />
        <section
          className="flex overflow-hidden flex-col items-center w-full text-white bg-black bg-opacity-70 max-md:max-w-full bg-cover bg-center min-h-[420px]"
          style={{
            backgroundImage: `url('https://admin.regional-group.com/storage/${GAleryBunner.data[0].image}')`,
          }}
        >
          <div className="w-full min-h-[420px] bg-black bg-opacity-70 flex justify-center items-center">
            <div className="flex flex-col max-w-full w-[856px]">
              <div className="flex flex-col w-full text-center items-center h-full">
                <h1 className="text-5xl font-semibold max-md:text-4xl">
                  {GAleryBunner.data[0].title}
                </h1>
                <div
                  className="text-lg leading-6 mt-5 px-2"
                  dangerouslySetInnerHTML={{
                    __html: GAleryBunner.data[0].description,
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="gallerItems">
          {GAlery?.data?.map((item: any) => (
            <div key={item.id} className="galeryItem">
              <a
                href={`https://admin.regional-group.com/storage/${item.image}`}
                data-fancybox={`gallery-${item.id}`}
                className="galeryItemMain"
              >
                <img
                  src={`https://admin.regional-group.com/storage/${item.image}`}
                  className="galleryImg"
                  alt=""
                />
                <img src={galleryTag} className="galleryTag" alt="" />
              </a>

              {item?.slides?.length > 0 && (
                <div className="otherImages" style={{ display: "none" }}>
                  {item.slides.map((slide: any, idx: number) => (
                    <a
                      key={idx}
                      href={`https://admin.regional-group.com/storage/${slide.image}`}
                      data-fancybox={`gallery-${item.id}`}
                    >
                      <img
                        src={`https://admin.regional-group.com/storage/${slide.image}`}
                        alt=""
                      />
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </section>

        <Pagination
          totalPages={GAlery.total_pages}
          currentPage={page}
          onPageChange={(num: number) => setPage(num)}
        />
        <Footer />
      </div>
    </>
  );
}
